// Test IDs for the AIROTECH MVP site + intake flow.
export const AIRO = {
  // Nav
  navHome: 'nav-home-logo',
  navWhy: 'nav-why',
  navWhatWeBuild: 'nav-what-we-build',
  navWork: 'nav-work',
  navHow: 'nav-how-it-works',
  navLevels: 'nav-build-levels',
  navStory: 'nav-our-story',
  navStart: 'nav-start-journey-btn',
  navMenu: 'nav-mobile-menu',
  // Hero / home
  heroStart: 'hero-start-journey-btn',
  heroBuild: 'hero-see-what-we-build-btn',
  // Reusable CTAs
  startCta: 'start-journey-cta',
  storyStart: 'story-start-journey-btn',
  storyEcosystem: 'story-why-airotech',
  exploreInc: 'explore-airotech-inc',
  closingStart: 'closing-start-journey-btn',
  tiersStart: 'tiers-start-journey-btn',
  // Work
  workCard: 'work-card',
  workBack: 'work-detail-back',
  // Intake
  intakeRoot: 'intake-root',
  intakeProgress: 'intake-progress',
  identityIndividual: 'identity-individual',
  identityCompany: 'identity-company',
  fieldPartyName: 'field-party-legal-name',
  fieldCompanyName: 'field-company-legal-name',
  fieldEntityType: 'field-entity-type',
  fieldFormation: 'field-formation-jurisdiction',
  fieldTitle: 'field-title-role',
  fieldEmail: 'field-email',
  fieldPhone: 'field-phone',
  fieldWebsiteHoney: 'field-website-honeypot',
  ideaWhat: 'idea-what-building',
  ideaWho: 'idea-who-for',
  ideaProblem: 'idea-problem-solved',
  ideaActions: 'idea-desired-actions',
  ideaExtra: 'idea-anything-else',
  // Product Inquiry (3 structured MC questions)
  inquiryProduct: 'inquiry-product-type',
  inquiryAudience: 'inquiry-audience-type',
  inquiryProblem: 'inquiry-problem-type',
  inquiryOtherProduct: 'inquiry-product-other',
  inquiryOtherAudience: 'inquiry-audience-other',
  inquiryOtherProblem: 'inquiry-problem-other',
  stepNext: 'intake-step-next',
  stepBack: 'intake-step-back',
  viewNda: 'view-nda-btn',
  ndaModal: 'nda-modal',
  ndaModalClose: 'nda-modal-close',
  ndaAcceptCheckbox: 'nda-accept-checkbox',
  authorityCheckbox: 'authority-checkbox',
  fieldSignature: 'field-typed-signature',
  submitIdea: 'submit-idea-btn',
  successScreen: 'success-screen',
  continueAssessment: 'continue-assessment-btn',
  // Assessment (Phase 2)
  assessmentRoot: 'assessment-root',
  assessmentEmail: 'assessment-email',
  assessmentVerify: 'assessment-verify-btn',
  assessmentProgress: 'assessment-progress',
  assessmentText: 'assessment-text',
  assessmentDetail: 'assessment-detail',
  assessmentNext: 'assessment-next',
  assessmentBack: 'assessment-back',
  assessmentComplete: 'assessment-complete-screen',
  assessmentPreparing: 'assessment-preparing',
  assessmentOption: 'assessment-option',
  assessmentOther: 'assessment-other-input',
};
